import { RidangoReduxAction } from '@ridango/core';

import { BookRideStatus, RidePlannerState } from '../ride-planner.model';
import { RidePlannerActions } from './ride-planner.actions';

export const RIDE_PLANNER_STATE_KEY = 'ridePlanner';

export const RIDE_PLANNER_INITIAL_STATE: RidePlannerState = {
    plan: {
        dateAndTime: null,
        priority: null,
        pickupFeature: null,
        dropoffFeature: null,
        stopovers: [],
    },
    specification: {
        companion: null,
        additionalInformation: '',
        isInvoice: null,
        productId: null,
    },
    bookingId: null,
    bookingStatus: BookRideStatus.OPEN,
    estimatedPrice: null,
    step: 1,
    error: null,
    loading: false,
    isReturn: false,
    products: [],
    potentialStops: [],
    filteredStops: []
};

export function ridePlannerReducer(
    state: RidePlannerState = RIDE_PLANNER_INITIAL_STATE,
    action: RidangoReduxAction
): RidePlannerState {
    switch (action.type) {
        case RidePlannerActions.SET_PLAN:
            return {
                ...state,
                plan: { ...state.plan, ...action.payload },
                step: 2,
            };
        case RidePlannerActions.SET_STEP:
            return {
                ...state,
                step: action.payload,
            };
        case RidePlannerActions.SET_PASSENGER:
            return {
                ...state,
                specification: {
                    ...state.specification,
                    companion: action.payload,
                },
            };
        case RidePlannerActions.SET_PRODUCT_ID:
            return {
                ...state,
                specification: {
                    ...state.specification,
                    productId: action.payload,
                },
            };
        case RidePlannerActions.SET_ESTIMATED_PRICE:
            return {
                ...state,
                estimatedPrice: action.payload,
            };
        case RidePlannerActions.SET_ADDITIONAL_INFORMATION:
            return {
                ...state,
                specification: {
                    ...state.specification,
                    additionalInformation: action.payload,
                },
            };
        case RidePlannerActions.SET_PAYMENT_TYPE:
            return {
                ...state,
                specification: {
                    ...state.specification,
                    isInvoice: action.payload,
                },
            };
        case RidePlannerActions.SET_IS_RETURN:
            return {
                ...state,
                isReturn: action.payload,
            };
        case RidePlannerActions.FETCH_ESTIMATED_PRICE_SUCCESS:
            return {
                ...state,
                estimatedPrice: action.payload,
            };
        case RidePlannerActions.FETCH_PRODUCTS_SUCCESS:
            return {
                ...state,
                products: action.payload,
            };
        case RidePlannerActions.POST_BOOKING_FLOW:
            return {
                ...state,
                error: null,
                loading: true,
            };
        case RidePlannerActions.POST_BOOKING_FLOW_SUCCESS:
            return {
                ...state,
                bookingId: action.payload.id,
                bookingStatus: BookRideStatus.PENDING,
                step: 3,
                error: null,
                loading: false,
            };
        case RidePlannerActions.POST_BOOKING_FLOW_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case RidePlannerActions.RESET_SPECIFICATION:
            return {
                ...state,
                specification: {
                    companion: null,
                    additionalInformation: '',
                    isInvoice: null,
                },
                error: null,
            };
        case RidePlannerActions.FETCH_POTENTIAL_STOPS_SUCCESS:
            return {
                ...state,
                potentialStops: action.payload,
                filteredStops: action.payload
            };
        case RidePlannerActions.FETCH_FILTERED_STOPS_SUCCESS:
            return {
                ...state,
                filteredStops: action.payload,
            };
    }

    return state;
}

export interface RidePlannerPartialStoreState {
    [RIDE_PLANNER_STATE_KEY]: RidePlannerState;
}
